export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const PT_BR = 'pt-BR';
